'use client';

import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { Switch } from '@/shared/ui/switch';
import { FormFieldProps } from './types';
import { mergeRefs } from './utils/mergeRefs';
import { parseRulesForInputAttributes } from './utils/parseRulesForInputAttributes';

type Props = FormFieldProps<typeof Switch> & {
    label?: ReactNode;
};
export const FormSwitch = ({
    id,
    name,
    control,
    label,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    ref,
    ...props
}: Props) => {
    return (
        <Controller
            {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
            render={({ field: { ref: fieldRef, value, onChange, ...field } }) => {
                return (
                    <>
                        <div>
                            <Switch
                                ref={mergeRefs([fieldRef, ref])}
                                id={id || name}
                                checked={value}
                                onChange={(e) => onChange(e.target.checked)}
                                {...parseRulesForInputAttributes(rules)}
                                {...field}
                                {...props}
                            />
                            {label && <label htmlFor={id || name}>{label}</label>}
                        </div>
                    </>
                );
            }}
        />
    );
};
